import { ClientRole } from '@cognitoforms/types/server-types/core/services/client-role';
import { globalStore } from 'src/stores/global-store';

/**
 * Map of required roles to the roles that fulfill the requirement
 */
const allowedRolesMap = {
	Owner: [ClientRole.Owner],
	Administrator: [ClientRole.Owner, ClientRole.Administrator],
	Editor: [ClientRole.Owner, ClientRole.Administrator, ClientRole.Editor],
	Reviewer: [ClientRole.Owner, ClientRole.Administrator, ClientRole.Editor, ClientRole.Reviewer],
	LimitedAccess: [ClientRole.Owner, ClientRole.Administrator, ClientRole.Editor, ClientRole.Reviewer, ClientRole.LimitedAccess],
	Guest: [ClientRole.Owner, ClientRole.Administrator, ClientRole.Editor, ClientRole.Reviewer, ClientRole.LimitedAccess, ClientRole.Guest]
};

/**
 * Checks if the current user's role for the current org is sufficient for the specified required role
 * @param requiredRole The minimum role required
 * @returns True if the current role meets the requirement. False otherwise.
 */
export function checkRole(requiredRole: ClientRole): boolean {
	const orgRole = globalStore.organization.Role;

	const allowedRoles = allowedRolesMap[requiredRole];

	if (!allowedRoles)
		return false;

	return allowedRoles.includes(orgRole);
};